<template>
  <div v-on:keyup.esc="limpiarTabla">
    <v-container v-if="user">
      <v-card>
        <v-card-title class="text-center teal lighten-3 accent-4 white--text">
          Precios y Existencias
          <v-spacer></v-spacer>
        </v-card-title>
        <v-row class="mx-2">
          <v-col cols="12" md="3" sm="3">
            <v-text-field
              label="Código producto"
              v-model="codigo_producto"
              @keydown="onKeyDown($event)"
            />
          </v-col>
          <v-col class="mt-4" cols="12" md="2" sm="2">
            <v-btn @click="simularTeclaEnter">Enviar </v-btn>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="sucursalSelected"
              :items="sucursales"
              item-value="value"
              label="Sucursal"
              placeholder="Selecciona sucursal"
              @change="cambiarSucursal"
            >
            </v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="almacenSelected"
              label="Almacen"
              :items="almacenes"
              item-value="value"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row class="mx-2">
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="etiquetasSelected"
              :items="etiquetas"
              chips
              small-chips
              clearable
              deletable-chips
              label="Etiquetas"
              multiple
              auto-select-first
              no-data-text="Sin coincidencias"
              :search-input.sync="searchInputEtiquetas"
              @change="clearSearchInput"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="ingredientesSelected"
              :items="ingredientes"
              chips
              small-chips
              clearable
              deletable-chips
              label="Ingrediente activo"
              multiple
              auto-select-first
              no-data-text="Sin coincidencias"
              :search-input.sync="searchInputIngrediente"
              @change="clearSearchInput"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-dialog v-model="dialog" max-width="600">
          <v-list>
            <v-subheader>Guía de promoción</v-subheader>
            <v-list-item v-for="item in arrayGuiaPromocion" :key="item">
              <v-list-item-content>
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-dialog>

        <v-data-table
          :headers="visibleHeaders"
          :items="items"
          :footer-props="{
            'items-per-page-text': 'Productos por página',
          }"
          :header-props="{
            'sort-by-text': 'Ordenar por',
          }"
          no-data-text="No hay productos para mostrar"
          loading-text="Cargando..."
          :loading="loadingTable"
          @click:row="onRowClick"
        >
          <template
            v-slot:[`item.precio_publico`]="{ item }"
            v-if="headerVisiblesIncluyen('precio_publico')"
          >
            {{ item.precio_publico }}
          </template>
          <template
            v-slot:[`item.precio_mostrador`]="{ item }"
            v-if="headerVisiblesIncluyen('precio_mostrador')"
          >
            {{ item.precio_mostrador }}
          </template>
          <template
            v-slot:[`item.precio_veterinario`]="{ item }"
            v-if="headerVisiblesIncluyen('precio_veterinario')"
          >
            {{ item.precio_veterinario }}
          </template>
          <template
            v-slot:[`item.precio_subdistribuidor`]="{ item }"
            v-if="headerVisiblesIncluyen('precio_subdistribuidor')"
          >
            {{ item.precio_subdistribuidor }}
          </template>
          <template
            v-slot:[`item.precio_praderas`]="{ item }"
            v-if="headerVisiblesIncluyen('precio_praderas')"
          >
            {{ item.precio_praderas }}
          </template>
          <template
            v-slot:[`item.precio_AGPL`]="{ item }"
            v-if="headerVisiblesIncluyen('precio_AGPL')"
          >
            {{ item.precio_AGPL }}
          </template>
          <template
            v-slot:[`item.precio_ganadera`]="{ item }"
            v-if="headerVisiblesIncluyen('precio_ganadera')"
          >
            {{ item.precio_ganadera }}
          </template>
          <template
            v-slot:[`item.precio_mediano_productor`]="{ item }"
            v-if="headerVisiblesIncluyen('precio_mediano_productor')"
          >
            {{ item.precio_mediano_productor }}
          </template>
          <template
            v-slot:[`item.precio_medico`]="{ item }"
            v-if="headerVisiblesIncluyen('precio_medico')"
          >
            {{ item.precio_medico }}
          </template>
          <template
            v-slot:[`item.precio_cliente_clave`]="{ item }"
            v-if="headerVisiblesIncluyen('precio_cliente_clave')"
          >
            {{ item.precio_cliente_clave }}
          </template>
          <template
            v-slot:[`item.precio_cliente_vip`]="{ item }"
            v-if="headerVisiblesIncluyen('precio_cliente_vip')"
          >
            {{ item.precio_cliente_vip }}
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      items: [],
      ingredientes: [],
      etiquetas: [],

      codigo_producto: "",
      almacenSelected: "culiacan",
      sucursalSelected: "Culiacan",
      ingredientesSelected: [],
      etiquetasSelected: [],
      searchInputEtiquetas: "",
      searchInputIngrediente: "",

      loadingTable: false,

      productoSelected: {},
      dialog: false,
      arrayGuiaPromocion: [],

      headers: [
        {
          text: "Código",
          value: "codigo_producto",
        },

        {
          text: "Nombre",
          value: "nombre_producto",
        },
        {
          text: "Existencia",
          value: "existencia",
        },
        {
          text: "Precio público",
          value: "precio_publico",
        },
        {
          text: "Precio mostrador",
          value: "precio_mostrador",
        },
        {
          text: "Precio veterinario",
          value: "precio_veterinario",
        },

        {
          text: "Precio praderas",
          value: "precio_praderas",
        },
        {
          text: "Precio AGPL",
          value: "precio_AGPL",
        },
        {
          text: "Precio ganadera",
          value: "precio_ganadera",
        },
        {
          text: "Precio mediano productor",
          value: "precio_mediano_productor",
        },
        {
          text: "Precio medico",
          value: "precio_medico",
        },
        {
          text: "Precio subdistribuidor",
          value: "precio_subdistribuidor",
        },
        {
          text: "Precio cliente clave",
          value: "precio_cliente_clave",
        },
        {
          text: "Precio cliente vip",
          value: "precio_cliente_vip",
        },
        {
          text: "IVA",
          value: "iva",
        },
        {
          text: "IEPS",
          value: "ieps",
        },
      ],
      visibleHeaders: [],
      sucursales: [
        {
          text: "Mexicali",
          value: "Mexicali",
        },
        {
          text: "Cualican",
          value: "Culiacan",
        },
      ],
      almacenes: [
        {
          text: "mexicali",
          value: "mexicali",
        },
        {
          text: "culiacan",
          value: "culiacan",
        },
      ],
    };
  },
  methods: {
    cambiarSucursal() {
      // Cambiar el almacen seleccionado al cambiar la sucursal
      if (this.sucursalSelected === "Mexicali") {
        this.almacenSelected = "mexicali";
      } else if (this.sucursalSelected === "Culiacan") {
        this.almacenSelected = "culiacan";
      }
      this.limpiarTabla();
    },

    headerVisiblesIncluyen(campo) {
      return this.visibleHeaders.some((header) => header.value === campo);
    },

    async onRowClick(item) {
      this.productoSelected = item;
      // console.log(this.productoSelected);
      try {
        const response = await axios.get(
          `/productos/get_guia_de_promocion?codigo=${this.productoSelected.codigo_producto}`
        );
        console.log(response.data);
        this.arrayGuiaPromocion = response.data;
        this.dialog = true;
      } catch (error) {
        console.log(error);
        alert(error.response.data.detail);
      }
    },
    clearSearchInput() {
      // Establece el search-input en una cadena vacía cuando se selecciona un elemento
      this.searchInputEtiquetas = "";
      this.searchInputIngrediente = "";
    },
    mostrarEtiquetas() {
      console.log(this.etiquetasSelected);
      console.log(this.busqueda);
    },
    simularTeclaEnter() {
      const evento = new KeyboardEvent("keydown", { key: "Enter" });
      this.$el.dispatchEvent(evento);
      this.onKeyDown(evento);
    },
    async onKeyDown(event) {
      // Si la tecla presionada es Enter, se hace la busqueda
      if (event.key === "Enter") {
        //Quitar la comprobacion de codigo del producto
        this.loadingTable = true;
        this.limpiarTabla();

        //Se cream los strings para pasarlos a la solicitud si no estan vacios
        let codigoString = "";
        let etiquetasString = "";
        let ingredientesString = "";

        if (this.codigo_producto !== "") {
          codigoString = `&str_busqueda=${this.codigo_producto}`;
        }

        if (this.etiquetasSelected.length !== 0) {
          this.etiquetasSelected.forEach((etiqueta) => {
            etiquetasString = etiquetasString + `&etiquetas=${etiqueta}`;
          });
        }

        if (this.ingredientesSelected.length !== 0) {
          this.ingredientesSelected.forEach((ingrediente) => {
            ingredientesString =
              ingredientesString + `&ingredientes_activos=${ingrediente}`;
          });
        }

        axios
          .get(
            `/productos/get_precios_existencia?almacen=${this.almacenSelected}&sucursal=${this.sucursalSelected}${codigoString}${etiquetasString}${ingredientesString}`
          )
          .then((response) => {
            const productos = response.data.productos;

            if (productos.length > 0) {
              const camposVisibles = Object.keys(productos[0]);
              this.visibleHeaders = this.headers.filter((header) =>
                camposVisibles.includes(header.value)
              );
            } else {
              this.visibleHeaders = [];
            }

            // Aquí puedes manejar la respuesta de la API
            console.log(response.data.productos);
            this.items.push(...response.data.productos);
            this.loadingTable = false;
          })
          .catch((error) => {
            // Aquí puedes manejar los errores
            this.loadingTable = false;
            if (error.response.status === 404) {
              console.error(error);
              alert(`No se encotraron productos`);
            } else {
              console.error(error);
              alert(`Error: ${error}`);
            }
          });
        this.$nextTick(() => {
          this.codigo_producto = "";
        });
      }
    },
    limpiarTabla() {
      this.items = []; // Asignar un array vacío para limpiar la tabla
    },
    async getIngredientes() {
      try {
        const response = await axios.get(
          "/varios/get_clasificaciones?tipo=ingrediente_activo"
        );
        const ingredientesTransformados = response.data.valores.map(
          (ingrediente) => {
            const text = ingrediente
              .replace(/_/g, " ")
              .replace(/\b\w/g, (c) => c.toUpperCase());
            return { text, value: ingrediente };
          }
        );
        this.ingredientes = ingredientesTransformados;
        // console.log(this.ingredientes);
      } catch (error) {
        console.error(error);
      }
    },
    async getEtiquetas() {
      try {
        const response = await axios.get(
          "/varios/get_clasificaciones?tipo=etiqueta_producto"
        );
        // Crear un nuevo array transformado
        const etiquetasTransformadas = response.data.valores.map((etiqueta) => {
          const text = etiqueta
            .replace(/_/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase());
          return { text, value: etiqueta };
        });
        this.etiquetas = etiquetasTransformadas;
        // console.log(this.etiquetas);
      } catch (error) {
        console.error(error);
      }
    },
    getFormatoPrecio(precioNumero) {
      // Formatear el número utilizando una función personalizada
      const precio = precioNumero.toFixed(2); // Limitar a 2 decimales
      const separadorDecimal = precio.indexOf(".") !== -1 ? "." : "";
      const [parteEntera, parteDecimal] = precio.split(separadorDecimal);

      // Formatear la parte entera con separador de miles
      const parteEnteraFormateada = parteEntera.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        ","
      );

      return `$${parteEnteraFormateada}${separadorDecimal}${parteDecimal}`;
    },
  },
  created() {
    this.getIngredientes();
    this.getEtiquetas();
  },
  components: {},
  computed: {
    ...mapGetters(["user"]),
  },
};
</script>
